<template>
  <v-container
    fill-height
    justify-content-start
    :class="{ 'section-width': lgAndUp }"
    class="pa-0"
  >
    <v-layout v-if="activities.extendedActivity" column>
      <div class="activity-header">
        <div class="activity-title" :class="{ 'pl-0': xsOnly }">
          <v-icon @click="$router.go(-1)" color="white" class="ms-3 me-3">mdi-arrow-left</v-icon>
          <v-toolbar-title>{{ pageName }}</v-toolbar-title>
        </div>
        <v-img :set="url = coverImageUrl" :lazy-src="url" :src="url" />
      </div>
      <reservation-type-chip :reservationMethodType="reservationMethod.type" />
      <v-layout v-if="catalog" class="app-scroll-section">
        <v-flex class="app-scroll-section">
          <v-layout column class="full-height py-2">
            <div v-if="categories.length" class="ml-3 pt-3 primary--text" :class="{ 'title': smAndUp }">{{$t('reservations.categories')}}</div>
            <div
              v-for="(category, index) in categories"
              :key="'a' + index"
              @click="!state.loading ? openCategorySelection(category.category) : ''"
              :class="!state.loading ? 'clickable' : null"
            >
              <category-list-item :category="category" />
            </div>
            <div v-if="filterProducts.length" class="ml-3 pt-3 primary--text" :class="{ 'title': smAndUp }">{{$t('reservations.products')}}</div>
            <div
              v-for="(product, index) in filterProducts"
              :key="'b' + index"
              @click="!state.loading && !product.product.outOfStock ? openProductSelection(product.product) : ''"
              :class="!state.loading && !product.product.outOfStock ? 'clickable' : ''"
            >
              <product-list-item :product="product" />
            </div>
          </v-layout>
        </v-flex>
        <v-divider v-if="$vuetify.breakpoint.mdAndUp" vertical />
        <v-flex
          v-if="$vuetify.breakpoint.mdAndUp"
          md5
          class="full-height py-4"
        >
          <summary-data :isComponent="true"/>
        </v-flex>
      </v-layout>
      <v-layout v-else justify-center align-center class="full-height">
        <v-progress-circular indeterminate />
      </v-layout>
      <v-spacer/>
      <div class="pa-3" v-if="smAndDown && catalog">
        <summary-button-wrapper :goToRoute="routeNames.reservationSummary.name" />
      </div>
    </v-layout>
    <v-layout v-else justify-center align-center>
      <v-progress-circular indeterminate />
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'

import openingHoursMixins from '@/mixins/OpeningHours'
import reservationMixins from '@/mixins/Reservation'
import vuetifyMixins from '@/mixins/Vuetify'

import routeNames from '@/router/routes'
import router from '@/router'
import store from '@/store'

export default {
  beforeRouteEnter (to, from, next) {
    if (store.getters['activityReservations/isUnsaved'] && localStorage.getItem('reservationMethodType')) {
      next()
    } else {
      router.go(-1)
    }
  },
  data () {
    return {
      moment,
      routeNames,
    }
  },
  methods: {
    openProductSelection (product) {
      this.$router.push({
        name: routeNames.catalogProductSelection.name,
        params: { productId: product.id },
      })
      this.$store.commit('cart/setSelectedProduct', product)
    },
    openCategorySelection (category) {
      this.$router.push({
        name: routeNames.catalogCategorySelection.name,
        params: { catalogCategoryId: category.id },
      })
    },
  },
  created () {
    this.$store.dispatch('pages/get', { id: this.$route.params.pageId }).then((page) => {
      const activityId = page.pageSpecific.activityId
      const promises = []
      promises.push(this.$store.dispatch('activities/getCatalog', { id: activityId }))
      this.$store.commit('activityReservations/setField', {
        field: 'activityId',
        value: activityId,
      })
      promises.push(this.$store.dispatch('activities/getActivity', { id: activityId }))
      Promise.all(promises).catch(() => {})
    })
  },
  computed: {
    ...mapGetters({
      reservationMethod: 'activityReservations/reservationMethod',
      pageName: 'pages/pageName',
      coverImageUrl: 'pages/coverImageUrl',
    }),
    ...mapState({
      activities: (state) => state.activities,
      catalog: (state) => state.activities.catalog,
      state: (state) => state.state,
      cartProducts: (state) => state.cart.cartProducts,
      activityReservations: (state) => state.activityReservations,
    }),
    filterProducts () {
      return this.catalog.products.filter(extProduct => {
        return extProduct.product.active && extProduct.product.pricingGroupsWithPrices.length
      })
    },
    categories () {
      return this.catalog.categories.filter(extCategory => {
        return extCategory.category.active && extCategory.products.some(extProduct => {
          return extProduct.product.active && extProduct.product.pricingGroupsWithPrices.length
        })
      })
    },
  },
  components: {
    CategoryListItem: () => import('@/components/view-components/catalog/CategoryListItem.vue'),
    ProductListItem: () => import('@/components/view-components/catalog/ProductListItem.vue'),
    SummaryButtonWrapper: () => import('@/components/view-components/catalog/SummaryButtonWrapper.vue'),
    ReservationTypeChip: () => import('@/components/view-components/reservations/ReservationTypeChip.vue'),
    SummaryData: () => import('@/components/view-components/catalog/Summary.vue'),
  },
  mixins: [
    openingHoursMixins,
    reservationMixins,
    vuetifyMixins,
  ],
}
</script>

<style lang="scss" scoped>
.notranslate {
  transform: none !important;
}
.activity-header {
  max-width: 100%;
  min-height: 90px;
  max-height: 90px;
  overflow: hidden;
  display: flex;
  align-items: center;
  position: relative;
  & .activity-title {
    position: absolute;
    z-index: 1;
    top: 8px;
  }
}
</style>
